import { Card } from '../../../ui';
import React, { FunctionComponent, useEffect, useState } from 'react';
import { Spinner } from '../../../ui';
import { useServiceErrorHandler } from '../../../../hooks/useServiceErrorHandler';
import { isAuthenticated } from '../../../../services/authentication';
import * as twitter from '../../../../services/twitter';

const TwitterPopupPage: FunctionComponent = () => {
  const handleServiceError = useServiceErrorHandler();

  const [isAuth] = useState(isAuthenticated());

  useEffect(() => {
    twitter
      .getTwitterLoginLink(isAuth)
      .then(twitterLoginLink => {
        document.location.href = twitterLoginLink;
      })
      .catch(error => handleServiceError(error));
  }, [isAuth, handleServiceError]);

  return (
    <div>
      <Card>
        <Card.Body>
          <h1 className="flex items-center justify-center gap-2 text-2xl font-bold text-gray-900 mb-6">
            <Spinner animation="grow"></Spinner> Loading Twitter...
          </h1>
        </Card.Body>
      </Card>
    </div>
  );
};

export default TwitterPopupPage;
